import { z } from 'zod';

/**
 * 웹 ↔ 네이티브 메시지 봉투.
 *
 * RN WebView 는 단방향 문자열 채널만 준다. 요청/응답 상관은 우리가 직접 만든다.
 * 모든 수신 메시지는 Zod 로 검증한다 — WebView 의 message 채널은 서드파티 스크립트가
 * 오염시킬 수 있는 공용 통로이기 때문이다.
 */

export const PROTOCOL_VERSION = 1 as const;

export const reqSchema = z.object({
  v: z.literal(PROTOCOL_VERSION),
  kind: z.literal('req'),
  id: z.string().min(1).max(64),
  method: z.string().min(1).max(64),
  params: z.unknown().optional(),
});

export const resSchema = z.discriminatedUnion('ok', [
  z.object({
    v: z.literal(PROTOCOL_VERSION),
    kind: z.literal('res'),
    id: z.string().min(1).max(64),
    ok: z.literal(true),
    result: z.unknown().optional(),
  }),
  z.object({
    v: z.literal(PROTOCOL_VERSION),
    kind: z.literal('res'),
    id: z.string().min(1).max(64),
    ok: z.literal(false),
    error: z.object({ code: z.string(), message: z.string() }),
  }),
]);

export const evtSchema = z.object({
  v: z.literal(PROTOCOL_VERSION),
  kind: z.literal('evt'),
  topic: z.string().min(1).max(64),
  payload: z.unknown().optional(),
});

export const inboundSchema = z.union([resSchema, evtSchema]);

export type Req = z.infer<typeof reqSchema>;
export type Res = z.infer<typeof resSchema>;
export type Evt = z.infer<typeof evtSchema>;
export type Inbound = z.infer<typeof inboundSchema>;

let counter = 0;
export function nextRequestId(): string {
  counter = (counter + 1) % 0xffffff;
  return `${Date.now().toString(36)}-${counter.toString(36)}`;
}
